import { GET } from "../utils/fetcher";
import qs from "querystring";
import { getSortingQueryString } from "helpers/sorting";
import { fetcher } from "@weezevent/weezjs-core";

export const getCheckpoints = (organizationId, query = {}) => {
	return GET(
		`/bo/organizers/${organizationId}/checkpoints/?${qs.stringify(query)}`
	);
};

export const createCheckpoint = ({ organizationId, eventId, data }) => {
	let endpoint;
	if (eventId) {
		endpoint = `/organizations/${organizationId}/events/${eventId}/checkpoints`;
	} else {
		endpoint = `/bo/organizers/${organizationId}/checkpoints/`;
	}

	const options = {
		endpoint: window.weezConfig.api.apiUrl,
		data
	};

	return fetcher.post(endpoint, {
		...options,
		cache: false
	});
};

export const updateCheckpoint = ({
	organizationId,
	eventId,
	checkpointId,
	data
}) => {
	let endpoint;
	if (eventId) {
		endpoint = `/organizations/${organizationId}/events/${eventId}/checkpoints/${checkpointId}`;
	} else {
		endpoint = `/bo/organizers/${organizationId}/checkpoints/${checkpointId}`;
	}

	const options = {
		endpoint: window.weezConfig.api.apiUrl,
		data
	};

	return fetcher.patch(endpoint, {
		...options,
		cache: false
	});
};

export const getEvents = (organizationId, queryParams) =>
	fetcher.get(`/bo/organizers/${organizationId}/events/`, {
		endpoint: window.weezConfig.api.apiUrl,
		query: queryParams,
		cache: false
	});

// TODO: generalize this interface (with an optional params arg),
//  and factorize the implementation with weezevent/core's fetcher
export const getSkidataIntegrationsList = (organizationId, params = {}) =>
	fetcher.get(`/bo/organizers/${organizationId}/integrations/skidata`, {
		endpoint: window.weezConfig.api.apiUrl,
		query: params,
		cache: false
	});

export const getSkidataIntegration = (
	organizationId,
	integrationId,
	params = {}
) =>
	fetcher.get(
		`/bo/organizers/${organizationId}/integrations/skidata/${integrationId}`,
		{
			endpoint: window.weezConfig.api.apiUrl,
			query: params,
			cache: false
		}
	);

export const getForms = ({ organizationId, eventId, queryParams = {} }) =>
	fetcher.get(`/organizations/${organizationId}/events/${eventId}/forms`, {
		endpoint: window.weezConfig.api.apiUrl,
		query: queryParams,
		cache: false
	});

export const getOrganizationForms = ({ organizationId, params = {} }) =>
	fetcher.get(`/organizations/${organizationId}/forms`, {
		endpoint: window.weezConfig.api.apiUrl,
		query: params,
		cache: false
	});

// custom scan screen
export const createCustomScanScreen = (organizationId, body) => {
	return fetcher.post(`/organizations/${organizationId}/templates`, {
		data: JSON.stringify(body),
		endpoint: window.weezConfig.api.apiUrl
	});
};

export const getAllTemplates = (organizationId, params) => {
	const queryParams = params ? { search: params } : {};
	return fetcher.get(`/organizations/${organizationId}/templates`, {
		endpoint: window.weezConfig.api.apiUrl,
		query: queryParams,
		cache: false
	});
};

export const createTemplateDefinition = (organizationId, body) =>
	fetcher.post(`/organizations/${organizationId}/template_field_definition`, {
		endpoint: window.weezConfig.api.apiUrl,
		data: JSON.stringify(body),
		cache: false
	});

export const getRetrieveTemplate = (organizationId, templateId, params) => {
	const endpoint = `/organizations/${organizationId}/templates/${templateId}`;
	return fetcher.get(endpoint, {
		endpoint: window.weezConfig.api.apiUrl,
		query: params,
		cache: false
	});
};

export const updateTemplate = (organizationId, body, queryParams = {}) => {
	const endpoint = `/organizations/${organizationId}/templates/${body.id}`;

	const options = {
		endpoint: window.weezConfig.api.apiUrl,
		query: queryParams
	};

	return fetcher.put(endpoint, {
		...options,
		data: JSON.stringify(body)
	});
};

export const removeTemplate = (organizationId, id) =>
	fetcher.delete(`/organizations/${organizationId}/templates/${id}`, {
		endpoint: window.weezConfig.api.apiUrl,
		cache: false
	});

export const updatePatchTemplate = (organizationId, body) => {
	return fetcher.patch(
		`/organizations/${organizationId}/templates/${body.id}`,
		{
			endpoint: window.weezConfig.api.apiUrl,
			data: JSON.stringify(body),
			cache: false
		}
	);
};

export const getTemplateDefinition = (organizationId, queryParams = {}) => {
	const { withDefaultField = false } = queryParams;
	let endpoint = `/organizations/${organizationId}/template_field_definition`;

	if (withDefaultField) {
		endpoint += "?with_default_field=true";
	}

	return fetcher.get(endpoint, {
		endpoint: window.weezConfig.api.apiUrl,
		query: queryParams,
		cache: false
	});
};

export const updateTemplateDefinition = (organizationId, body) =>
	fetcher.put(
		`/organizations/${organizationId}/template_field_definition/${body.id}`,
		{
			endpoint: window.weezConfig.api.apiUrl,
			data: JSON.stringify({ ...body, id: undefined }),
			cache: false
		}
	);

export const removeTemplateDefinition = (organizationId, id) =>
	fetcher.delete(
		`/organizations/${organizationId}/template_field_definition/${id}`,
		{
			endpoint: window.weezConfig.api.apiUrl,
			cache: false
		}
	);

export const postIntegrationTestConnexion = (
	organizationId,
	integrationId,
	integration
) => {
	const integrationType = integration?.type;
	return fetcher.post(
		`/bo/organizers/${organizationId}/integrations/${integrationType}/${integrationId}/test`,
		{
			endpoint: window.weezConfig.api.apiUrl,
			data: JSON.stringify(integration),
			cache: false
		}
	);
};

export const postOrPatchEventConfig = (
	organizationId,
	eventId,
	eventConfig,
	patch = false
) => {
	const endpoint = `/organizations/${organizationId}/events/${eventId}/config`;
	const params = {
		endpoint: window.weezConfig.api.apiUrl,
		data: eventConfig
	};

	return patch
		? fetcher.patch(endpoint, params)
		: fetcher.post(endpoint, params);
};

export const getEventConfig = (organizationId, eventId, params) => {
	const endpoint = `/organizations/${organizationId}/events/${eventId}/config`;
	const options = {
		endpoint: window.weezConfig.api.apiUrl,
		query: params
	};
	return fetcher.get(endpoint, {
		...options,
		cache: false
	});
};

// GET event config periods
export const getEventConfigPeriods = (organizationId, eventId, params) => {
	const endpoint = `/organizations/${organizationId}/events/${eventId}/periods`;
	const options = {
		endpoint: window.weezConfig.api.apiUrl,
		query: params
	};
	return fetcher.get(endpoint, {
		...options,
		cache: false
	});
};

// GET ONE EVENT CONFIG PERIOD
export const getEventConfigPeriod = (
	organizationId,
	eventId,
	periodId,
	params
) => {
	const endpoint = `/organizations/${organizationId}/events/${eventId}/periods/${periodId}`;
	const options = {
		endpoint: window.weezConfig.api.apiUrl,
		query: params
	};
	return fetcher.get(endpoint, {
		...options,
		cache: false
	});
};

export const getEventPeriodsList = (organizationId, eventId, params) => {
	const endpoint = `/organizations/${organizationId}/events/${eventId}/periods`;
	const options = {
		endpoint: window.weezConfig.api.apiUrl,
		query: params,
		cache: false
	};

	return fetcher.get(endpoint, options);
};

export const getEventPeriod = ({ organizationId, eventId, id, params }) => {
	const endpoint = `/organizations/${organizationId}/events/${eventId}/periods/${id}`;

	const options = {
		endpoint: window.weezConfig.api.apiUrl,
		query: params
	};

	return fetcher.get(endpoint, {
		...options,
		cache: false
	});
};

export const createEventPeriod = ({ organizationId, eventId, data }) => {
	const endpoint = `/organizations/${organizationId}/events/${eventId}/periods`;

	const options = {
		endpoint: window.weezConfig.api.apiUrl,
		data
	};

	return fetcher.post(endpoint, {
		...options,
		cache: false
	});
};

export const updateEventPeriod = ({ organizationId, eventId, id, data }) => {
	const endpoint = `/organizations/${organizationId}/events/${eventId}/periods/${id}`;

	const options = {
		endpoint: window.weezConfig.api.apiUrl,
		data
	};

	return fetcher.patch(endpoint, {
		...options,
		cache: false
	});
};

export const removeEventPeriod = ({ organizationId, eventId, id }) => {
	const endpoint = `/organizations/${organizationId}/events/${eventId}/periods/${id}`;

	const options = {
		endpoint: window.weezConfig.api.apiUrl
	};

	return fetcher.delete(endpoint, {
		...options,
		cache: false
	});
};

// CREATE event days (event config)
export const postEventsDaysConfig = (organizationId, eventId, requestBody) => {
	const endpoint = `/organizations/${organizationId}/events/${eventId}/event-days/actions`;
	const options = {
		endpoint: window.weezConfig.api.apiUrl,
		data: requestBody
	};
	return fetcher.post(endpoint, {
		...options
	});
};

//mapping ( get currencies)
export const getCurrencies = (organizationId, eventId, params) => {
	const endpoint = `/bo/organizers/${organizationId}/events/${eventId}/currencies`;
	const options = {
		endpoint: window.weezConfig.api.apiUrl,
		query: params
	};
	return fetcher.get(endpoint, {
		...options,
		cache: false
	});
};
export const requestPeriods = (
	organizationId,
	eventId,
	eventConfig,
	method = "POST",
	periodId = null
) => {
	let endpoint = `/organizations/${organizationId}/events/${eventId}/periods`;
	if (periodId) endpoint += `/${periodId}`;
	const params = {
		endpoint: window.weezConfig.api.apiUrl,
		data: eventConfig
	};

	switch (method) {
		case "PUT":
			return fetcher.put(endpoint, params);
		case "PATCH":
			return fetcher.patch(endpoint, params);
		case "POST":
		default:
			return fetcher.post(endpoint, params);
	}
};

export const triggerPartnerActions = ({ organizationId, data }) => {
	return fetcher.post(`/bo/organizers/${organizationId}/partners/actions/`, {
		data,
		endpoint: window.weezConfig.api.apiUrl
	});
};

export const getEventDays = ({ organizationId, eventId, params = {} }) => {
	const endpoint = `/organizations/${organizationId}/events/${eventId}/event-days`;
	const options = {
		endpoint: window.weezConfig.api.apiUrl,
		query: params,
		cache: false
	};

	return fetcher.get(endpoint, options);
};

const sortingMap = {
	creationDate: "date_joined",
	operators: "name",
	id: "username"
};
// GET PARTNERS LIST
export const getPartners = ({ organizationId, params = {} }) => {
	const sorting = params?.sorting || false;
	const queryParams = {
		limit: params?.limit || 100,
		offset: params?.offset || 0,
		search: params?.search || ""
	};

	if (params?.with_event_config) {
		queryParams.with_event_config = params.with_event_config;
	}

	if (sorting) {
		const sortingQuery = getSortingQueryString(sorting, sortingMap);
		Object.assign(queryParams, sortingQuery);
	}

	const endpoint = `/bo/organizers/${organizationId}/partners/`;

	return fetcher.get(endpoint, {
		cache: false,
		query: queryParams,
		endpoint: window.weezConfig.api.apiUrl
	});
};

// GET EVENT CONFIG PARTNERS LIST
export const getEventConfigPartners = ({
	organizationId,
	eventId,
	params = {}
}) => {
	const { limit = 50, offset = 0, search = "", sorting = null } = params;

	const queryParams = new URLSearchParams({
		limit,
		offset,
		search
	});

	if (sorting) {
		const sortingQuery = getSortingQueryString(sorting, sortingMap);
		Object.entries(sortingQuery).forEach(([key, value]) =>
			queryParams.append(key, value)
		);
	}

	const endpoint = `/organizations/${organizationId}/events/${eventId}/partners?${queryParams}`;

	return fetcher.get(endpoint, {
		cache: false,
		endpoint: window.weezConfig.api.apiUrl
	});
};
export const createEventDay = ({ organizationId, eventId, data }) => {
	const endpoint = `/organizations/${organizationId}/events/${eventId}/event-days`;
	const options = {
		data,
		endpoint: window.weezConfig.api.apiUrl
	};

	return fetcher.post(endpoint, options);
};

export const updateEventDay = ({ organizationId, eventId, id, data }) => {
	const endpoint = `/organizations/${organizationId}/events/${eventId}/event-days/${id}`;
	const options = {
		data,
		endpoint: window.weezConfig.api.apiUrl
	};

	return fetcher.patch(endpoint, options);
};

export const deleteEventDay = ({ organizationId, eventId, id }) => {
	const endpoint = `/organizations/${organizationId}/events/${eventId}/event-days/${id}`;
	const options = {
		endpoint: window.weezConfig.api.apiUrl
	};

	return fetcher.delete(endpoint, options);
};
// GET PARTNER (EVENT CONFIG LEVEL)
export const getPartner = (organizationId, eventId, partnerId, params = {}) => {
	let endpoint;
	if (eventId) {
		endpoint = `/organizations/${organizationId}/events/${eventId}/partners/${partnerId}`;
	} else {
		endpoint = `/bo/organizers/${organizationId}/partners/${partnerId}`;
	}
	const options = {
		endpoint: window.weezConfig.api.apiUrl,
		query: params,
		cache: false
	};
	return fetcher.get(endpoint, options);
};

// UPDATE PARTNER ( EVENT CONFIG LEVEL)
export const updatePartner = ({ organizationId, eventId, id, data }) => {
	let endpoint;
	if (eventId) {
		endpoint = `/organizations/${organizationId}/events/${eventId}/partners/${id}`;
	} else {
		endpoint = `/bo/organizers/${organizationId}/partners/${id}`;
	}
	const options = {
		data,
		endpoint: window.weezConfig.api.apiUrl
	};

	return fetcher.patch(endpoint, options);
};

// CREATE PARTNER (EVENT CONFIG LEVEL)
export const createPartner = ({ organizationId, eventId, data }) => {
	let endpoint;
	if (eventId) {
		endpoint = `/organizations/${organizationId}/events/${eventId}/partners`;
	} else {
		endpoint = `/bo/organizers/${organizationId}/partners/`;
	}

	const options = {
		data,
		endpoint: window.weezConfig.api.apiUrl
	};

	return fetcher.post(endpoint, options);
};

// DELETE PARTNER (EVENT CONFIG LEVEL)
export const deletePartner = ({ organizationId, eventId, partnerId }) => {
	let endpoint;
	if (eventId) {
		endpoint = `/organizations/${organizationId}/events/${eventId}/partners/${partnerId}`;
	} else {
		endpoint = `/bo/organizers/${organizationId}/partners/${partnerId}`;
	}
	const options = {
		endpoint: window.weezConfig.api.apiUrl
	};

	return fetcher.delete(endpoint, options);
};

export const getEventConfigCheckpoints = (
	organizationId,
	eventId,
	params = {}
) => {
	let endpoint;
	if (eventId) {
		endpoint = `/organizations/${organizationId}/events/${eventId}/checkpoints`;
	} else {
		endpoint = `/bo/organizers/${organizationId}/checkpoints`;
	}
	const options = {
		endpoint: window.weezConfig.api.apiUrl,
		query: params,
		cache: false
	};
	return fetcher.get(endpoint, options);
};

export const getOneCheckpoint = ({
	organizationId,
	eventId,
	checkpointId,
	params = {}
}) => {
	let endpoint;
	if (eventId) {
		endpoint = `/organizations/${organizationId}/events/${eventId}/checkpoints/${checkpointId}`;
	} else {
		endpoint = `/bo/organizers/${organizationId}/checkpoints/${checkpointId}`;
	}
	const options = {
		endpoint: window.weezConfig.api.apiUrl,
		query: params,
		cache: false
	};
	return fetcher.get(endpoint, options);
};

export const triggerChecklistsActions = ({ organizationId, data }) => {
	return fetcher.post(
		`/bo/organizers/${organizationId}/checkpoints/actions/`,
		{
			data,
			endpoint: window.weezConfig.api.apiUrl
		}
	);
};

// GET TAG GROUPS FROM MUSHU
export const getTagGroups = (organizationId, params = {}) => {
	const endpoint = `/organizations/${organizationId}/tag-groups`;

	const options = {
		endpoint: window.weezConfig.api.apiUrl,
		query: params,
		cache: false
	};

	return fetcher.get(endpoint, options);
};

// GET LIST OF RATES
export const getRateList = (organizationId, params) => {
	const endpoint = `/organizations/${organizationId}/rates`;
	const options = {
		endpoint: window.weezConfig.api.apiUrl,
		query: params,
		cache: false
	};

	return fetcher.get(endpoint, options);
};

export const getDeviceStatusList = (organizationId, params = {}) => {
	const endpoint = `/organizations/${organizationId}/device-status-v2`;

	const options = {
		endpoint: window.weezConfig.api.apiUrl,
		query: params,
		cache: false
	};

	return fetcher.get(endpoint, options);
};

export const getDeviceStatusStats = organizationId => {
	const endpoint = `/organizations/${organizationId}/device-status-v2/stats`;

	const options = {
		endpoint: window.weezConfig.api.apiUrl,
		cache: false
	};

	return fetcher.get(endpoint, options);
};

export const getAttendeeIdentifications = (
	organizationId,
	eventId,
	attendeeId,
	params = {}
) => {
	const endpoint = `/organizations/${organizationId}/events/${eventId}/identifications?attendee_id=${attendeeId}`;

	const options = {
		endpoint: window.weezConfig.api.apiUrl,
		query: params,
		cache: false
	};

	return fetcher.get(endpoint, options);
};

export const updateAttendeeIdentifications = (
	organizationId,
	eventId,
	requestBody
) => {
	const endpoint = `/organizations/${organizationId}/events/${eventId}/identifications/actions`;

	const options = {
		endpoint: window.weezConfig.api.apiUrl,
		data: requestBody
	};
	return fetcher.post(endpoint, {
		...options
	});
};

// Get mapping list
export const getMappingList = (organizationId, params) => {
	const endpoint = `/organizations/${organizationId}/template_field_definition`;
	const options = {
		endpoint: window.weezConfig.api.apiUrl,
		query: params,
		cache: false
	};
	return fetcher.get(endpoint, options);
};

export const getAttendeeDetails = (id, organizationId, params) => {
	return GET(
		`/organizations/${organizationId}/attendees/${id}?` +
			qs.stringify(params),
		false,
		undefined
	);
};

export const getEventAttendeeDetails = (
	id,
	organizationId,
	eventId,
	params
) => {
	return GET(
		`/organizations/${organizationId}/events/${eventId}/attendees/${id}?` +
			qs.stringify(params),
		false,
		undefined
	);
};

export const getFilteredScans = (organizationId, attendeeIds, filters = {}) => {
	const endpoint = `/organizations/${organizationId}/scans`;
	const queryParams = {
		attendees: attendeeIds.join(","),
		...filters
	};

	const options = {
		endpoint: window.weezConfig.api.apiUrl,
		query: queryParams,
		cache: false
	};

	return fetcher.get(endpoint, options);
};

// GET SCANS STATISTICS
export const getScansStatistics = (organizationId, params = {}) => {
	const endpoint = `/organizations/${organizationId}/scans`;
	const options = {
		endpoint: window.weezConfig.api.apiUrl,
		query: params,
		cache: false
	};

	return fetcher.get(endpoint, options);
};
